// @ts-nocheck
import React, { useState } from "react";
import styled from "styled-components";

import CheckIcon from "@material-ui/icons/Check";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

import { ReactComponent as UserGroupIcon } from "../../../assets/icons/user-group.svg";
import { ReactComponent as UserIndividualIcon } from "../../../assets/icons/user-individual.svg";
import { Aviso } from "./ui";

const NOME_PLANO = {
  ESSENTIAL: "Essencial",
  PREMIUM: "Premium",
  EXCLUSIVE: "Exclusivo",
  PLAN_2026: "Assessoria completa",
  PLAN_ANALISE: "Plano Análise",
};

const Topo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--cinza-30);

  h3 {
    font-size: var(--font-21);
    line-height: 1.3;
    font-weight: 900;
    color: var(--cinza-100);
    margin: 0;
    overflow-wrap: anywhere;
  }

  .tipo {
    font-size: 14px;
    color: var(--cinza-70);
    margin: 0;
  }

  .chips {
    display: flex;
    gap: 8px;
    margin-top: 10px;
    flex-wrap: wrap;
  }

  .pt {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 34px;
    border: 1px solid var(--cinza-30);
    border-radius: 8px;
    padding: 0 10px;
    font: 600 12px monospace;
    color: var(--cinza-100);
    background: var(--white);
    cursor: pointer;

    svg {
      font-size: 14px;
      color: var(--cinza-80);
    }
  }

  .pt.copiado svg {
    color: var(--principal-50);
  }

  .chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
    font-weight: 700;
    color: var(--cinza-90);
    background: var(--cinza-20);

    svg {
      width: 16px;
      height: 16px;
    }
  }

  ${Aviso} {
    margin-top: 12px;
  }
`;

// Quem é: requerente, tipo · plano, PT (copiar) e Individual/Apensado.
export default function Cabecalho({ process, apensado, aguardaApensados, apensadoCompleto }) {
  const [copiado, setCopiado] = useState(false);
  const pt = process?.service_code;
  const plano = NOME_PLANO[process?.sale?.family_plan];

  const copiar = () => {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(pt).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1500);
    });
  };

  return (
    <Topo>
      <h3>{process?.applicant?.name}</h3>
      <p className="tipo">{[process?.type, plano].filter(Boolean).join(" · ")}</p>
      <div className="chips">
        {pt && (
          <button type="button" className={`pt ${copiado ? "copiado" : ""}`} aria-label={`Copiar número do pedido ${pt}`} onClick={copiar}>
            {pt}
            {copiado ? <CheckIcon /> : <FileCopyOutlinedIcon />}
          </button>
        )}
        <span className="chip">
          {apensado ? <UserGroupIcon /> : <UserIndividualIcon />}
          {apensado ? "Apensado" : "Individual"}
        </span>
      </div>
      {aguardaApensados && (
        <Aviso tipo="obstaculo">
          <b>Aguardando apensados para seguir</b>
        </Aviso>
      )}
      {apensado && !apensadoCompleto && (
        <Aviso tipo="neutro">
          <p>
            <b>Aviso:</b> todos os pedidos apensados só passam para a próxima etapa juntos, mesmo que a documentação de um deles já esteja completa.
          </p>
        </Aviso>
      )}
    </Topo>
  );
}
